<template>
  <div class="ibox">
    <div class="ibox-title">
      <h2>Load Details</h2>
    </div>
    <div class="ibox-content">
      <ul class="list-detail list-detail-load-breakdown">
        <client-load v-for="(load, index) in loadsOrderedByLoadingDate" :key="load.id" :load="load" :index="index"></client-load>

        <li v-if="haveNoLoads" class="text-center text-muted">
          There are no loads.
        </li>
      </ul>
    </div>
    <div class="ibox-footer">
      <p class="assigned">Assigned: {{ loadSize }} of {{ jobSize }} tonnes. ({{ loadPercentage }}%)</p>
    </div>

    <load-check-modal v-if="haveLoadWithWeighbridge"></load-check-modal>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { orderBy } from 'lodash'
  import { assignedTonnageHelpers } from 'mixins/loads'
  import { jobHelpers } from 'mixins/jobs'
  import ClientLoad from './ClientLoad'
  import LoadCheckModal from 'components/loads/LoadCheckModal'
  import moment from 'moment'

  export default {
    mixins: [assignedTonnageHelpers, jobHelpers],

    components: {
      ClientLoad,
      LoadCheckModal
    },

    computed: {
      ...mapGetters('load', ['haveLoadWithWeighbridge']),

      /**
       * Get the loads ordered by the loading date.
       *
       * @return array
       */
      loadsOrderedByLoadingDate () {
        const orderByLoadingDate = load => {
          return moment(load.loading_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
        }

        return orderBy(this.loads, [orderByLoadingDate, 'id'], ['asc', 'asc'])
      },

      /**
       * Determine if we have no loads.
       *
       * @return boolean
       */
      haveNoLoads () {
        return this.haveJob && this.loads.length === 0
      }
    },

    created () {
      this.getLoads()

      // When the jobs status changes this likely means we have a cancelled job so
      // we need to refetch all the loads.
      this.$watch('job.status', () => (this.getLoads()))
    },

    methods: {
      ...mapActions('job/load', ['getLoads'])
    }
  }
</script>



// WEBPACK FOOTER //
// ClientLoadList.vue?5bd5b9f6